import {isLoggedIn} from 'utils/auth'

export default (store) => {
  return ({
    path: 'labeling',
    onEnter: isLoggedIn(store),
    getComponent(nextState, cb) {
      require.ensure([], (require) => {
        const Labeling = require('./containers/Labeling').default;
        cb(null, Labeling)
      }, 'offer')
    }
  })
}

// isLoggedIn(store)


// WEBPACK FOOTER //
// ./src/routes/Labeling/index.js